import {IAzureSearchResponse} from "@/shared/services/azure-search-service";
import {SearchResult, SearchResultImage} from "../models/search-result-model";
import {SearchResponse} from "../models/search-reponse-model";

export interface IAzureSearchMapper<T> {
    createResponse(response: IAzureSearchResponse<T>): SearchResponse

    mapResults(items: T[]): SearchResult[]

    mapResult(item: T): SearchResult

    mapImage(url: string, alt: string): SearchResultImage
}

export abstract class AzureSearchMapper<T> implements IAzureSearchMapper<T> {
    createResponse(response: IAzureSearchResponse<T>): SearchResponse {
        return new SearchResponse(
            this.mapResults(response.value),
            response['@odata.count'],
            response['@search.facets']
        )
    }

    mapResults(items: T[]): SearchResult[] {
        return items.map((item: T) => this.mapResult(item))
    }

    abstract mapResult(item: T): SearchResult

    mapImage(url: string, alt: string): SearchResultImage {
        return new SearchResultImage(url, alt)
    }
}
